import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const TipoInventarioService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Inventario_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_tipo_inventario: null,
			tipo_inventario: form.tipo_inventario,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Inventario_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_tipo_inventario: form.id_cat_tipo_inventario,
			tipo_inventario: form.tipo_inventario,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Inventario_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_tipo_inventario) => {
		let params = {
			id_cat_tipo_inventario: id_cat_tipo_inventario
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Inventario_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
